import KickImage from 'Reuseables/KickImage';
import { Component } from 'react';
import { Card, CardText, CardTitle } from 'reactstrap';
import IlustrasiVA from "../../../images/ilustrasi-virtual-account.png";

export default class VirtualAccount extends Component{
    render(){
        return (
            <Card body>
                <CardTitle>Virtual Account</CardTitle>
                <CardText>
                    Metode Bank Transfer merupakan metode pembayaran dengan cara transfer ke 
                    salah satu nomor virtual account yang telah disediakan. Untuk saat ini kami menyediakan tiga virtual account
                    yaitu BCA, Mandiri, dan BNI. 
                    Disarankan untuk tidak melakukan transfer beda bank, apabila anda tidak memiliki rekening dengan bank yang sama dengan virtual acccount yang telah disediakan diharapkan untuk memilih metode pembayaran yang lain. 
                    Terdapat dua penyedia jasa virtual account, yaitu Midtrans dan Xendit/PT Sinar Digital Terdepan.
                </CardText>

                <KickImage src={IlustrasiVA} style={{ width: "80%", alignSelf: "center", marginBottom: "1rem" }} />

                <CardText>Berikut panduan membayar dengan menggunakan metode virtual account:</CardText>

                <CardTitle>Penyedia jasa Midtrans (Kode Perusahaan: 70012)</CardTitle>
                <Card>
                    <CardTitle>BCA</CardTitle>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>ATM BCA</CardTitle>
                        <ol>
                            <li>On the main menu, choose "Other Transaction"</li>
                            <li>Choose "Transfer"</li>
                            <li>Choose "Transfer To BCA Virtual Account"</li>
                            <li>Enter your "Payment Code" (11 digits code) and press "Correct"</li>
                            <li>Enter the full amount to be paid and press "Correct"</li>
                            <li>Your payment details will appear on the payment confirmation page. If the information is correct press "Yes"</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Klik BCA</CardTitle>
                        <ol>
                            <li>Choose Menu "Fund Transfer"</li>
                            <li>Choose "Transfer To BCA Virtual Account"</li>
                            <li>"Input BCA Virtual Account Number" or "Choose from Transfer list" and click "Continue"</li>
                            <li>Amount to be paid, account number and Merchant name will appear on the payment confirmation page, if the information is right click "Continue"</li>
                            <li>Get your BCA token and input KEYBCA Response "APPLI 1" and click "Submit"</li>
                            <li>Your Transaction is Done</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>m-BCA</CardTitle>
                        <ol>
                            <li>Log in to your "BCA Mobile" app</li>
                            <li>Choose "m-BCA", then input your "m-BCA access code"</li>
                            <li>Choose "m-Transfer", then choose BCA Virtual Account</li>
                            <li>Input Virtual Account Number or choose an existing account from "Daftar Transfer"</li>
                            <li>Input the payable amount</li>
                            <li>Input your m-BCA pin</li>
                            <li>Payment is finished. Save the notification as your payment receipt</li>
                        </ol>                                        
                    </Card>
                </Card>
                <Card>
                    <CardTitle>Mandiri</CardTitle>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>ATM Mandiri</CardTitle>
                        <ol>
                            <li>On the main menu, choose "Pay/Buy"</li>
                            <li>Choose "Others"</li>
                            <li>Choose "Multi Payment"</li>
                            <li>Enter 70012 (Midtrans company code) and press "Correct"</li>
                            <li>Enter your Payment Code and press "Correct"</li>
                            <li>Your payment details will appear on the payment confirmation page. If the information is correct press "Yes"</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Internet Banking</CardTitle>
                        <ol>
                            <li>Login to Mandiri Internet Banking <a href="https://ibank.bankmandiri.co.id/">https://ibank.bankmandiri.co.id/</a></li>
                            <li>From the main menu choose "Payment", then choose "Multi Payment"</li>
                            <li>Select your account in From Account, then in Billing Name select Midtrans</li>
                            <li>Enter the Payment Code and you will receive your payment details</li>
                            <li>Confirm your payment using your Mandiri Token</li>
                        </ol>                                        
                    </Card>
                </Card>
                <Card>
                    <CardTitle>BNI</CardTitle>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>ATM BNI</CardTitle>
                        <ol>
                            <li>On the main menu, choose "Others"</li>
                            <li>Choose "Transfer"</li>
                            <li>Choose "Savings Account"</li>
                            <li>Choose "To BNI Account"</li>
                            <li>Enter the payment account number and press "Yes"</li>
                            <li>Enter the full amount to be paid. If the amount entered is not the same as the invoiced amount, the transaction will be declined</li>
                            <li>Amount to be paid, account number, and merchant name will appear on the payment confirmation page. If the information is correct, press Yes</li>
                            <li>You are done</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Internet Banking</CardTitle>
                        <ol>
                            <li>Go to <a href="https://ibank.bni.co.id">https://ibank.bni.co.id</a> and then click "Login"</li>
                            <li>Continue login with your User ID and Password</li>
                            <li>Click "Transfer" and then "Add Favorite Account" and choose "Antar Rekening BNI"</li>
                            <li>Enter account name, account number, and email and then click "Continue"</li>
                            <li>Input the Authentification Code from your token and then click "Continue"</li>
                            <li>Back to main menu and select "Transfer" and then "Transfer Antar Rekening BNI"</li>
                            <li>Pick the account that you just created in the previous step as Rekening Tujuan and fill in the rest before clicking "Continue"</li>
                            <li>Check whether the details are correct, if they are, please input the Authentification Code and click "Continue" and you are done</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Mobile Banking</CardTitle>
                        <ol>
                            <li>Open the BNI Mobile Banking app and login</li>
                            <li>Choose menu "Transfer"</li>
                            <li>Choose menu "Virtual Account Billing"</li>
                            <li>Choose the bank account you want to use</li>
                            <li>Enter the 16 digits virtual account number</li>
                            <li>The billing information will appear on the payment validation page</li>
                            <li>If the information is correct, enter your password to proceed the payment</li>
                            <li>Your transaction will be processed</li>
                        </ol>                                        
                    </Card>
                </Card>

                <CardTitle>Penyedia jasa Xendit/PT Sinar Digital Terdepan (Kode Perusahaan: 88464)</CardTitle>
                <Card>
                    <CardTitle>BCA</CardTitle>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Melalui ATM</CardTitle>
                        <ol>
                            <li>Masukkan kartu ATM dan PIN BCA Anda</li>
                            <li>Di Menu utama, pilih "Transaksi Lainnya". Pilih "Transfer". Pilih "Ke BCA Virtual Account"</li>
                            <li>Masukkan nomor Virtual Account 02xxx xxxx xx</li>
                            <li>Pastikan data virtual account Anda benar, kemudian masukkan angka yang perlu Anda bayarkan, kemudian pilih "BENAR"</li>
                            <li>Cek & perhatikan konfirmasi pembayaran dari layar ATM, jika sudah benar pilih "YA", atau pilih "TIDAK" jika data di layar masih salah</li>
                            <li>Transaksi Anda sudah selesai. Pilih "TIDAK" untuk tidak melanjutkan transaksi lain</li>
                            <li>Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Melalui Online</CardTitle>
                        <ol>
                            <li>Login ke KlikBCA Individual</li>
                            <li>Pilih "Transfer", kemudian pilih "Transfer ke BCA Virtual Account"</li>
                            <li>Masukkan nomor Virtual Account 02xxx xxxx xx</li>
                            <li>Pilih "Lanjutkan" untuk melanjutkan pembayaran</li>
                            <li>Masukkan "RESPON KEYBCA APPLI 1" yang muncul pada Token BCA Anda, lalu klik tombol "Kirim"</li>
                            <li>Transaksi Anda sudah selesai</li>
                            <li>Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Melalui mBanking</CardTitle>
                        <ol>
                            <li>Buka Aplikasi BCA Mobile</li>
                            <li>Pilih "m-BCA", kemudian pilih "m-Transfer"</li>
                            <li>Pilih "BCA Virtual Account"</li>
                            <li>Masukkan nomor Virtual Account 02xxx xxxx xx, lalu pilih "OK"</li>
                            <li>Klik tombol "SEND" yang berada di sudut kanan atas aplikasi untuk melakukan transfer</li>
                            <li>Klik "OK" untuk melanjutkan pembayaran</li>
                            <li>Masukkan PIN Anda untuk meng-otorisasi transaksi</li>
                            <li>Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.</li>
                        </ol>                                        
                    </Card>
                </Card>
                <Card>
                    <CardTitle>Mandiri</CardTitle>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Melalui ATM</CardTitle>
                        <ol>
                            <li>Masukkan kartu ATM dan pilih "Bahasa Indonesia"</li>
                            <li>Ketik nomor PIN kartu ATM</li>
                            <li>Pilih menu BAYAR/BELI, kemudian pilih menu MULTI PAYMENT</li>
                            <li>Ketik kode perusahaan, yaitu "88464" (PT SINAR DIGITAL TERDEPAN), tekan "BENAR"</li>
                            <li>Masukkan nomor Virtual Account 88464 xxxx xx</li>
                            <li>Isi NOMINAL, kemudian tekan "BENAR"</li>
                            <li>Muncul konfirmasi data customer. Pilih Nomor 1 sesuai tagihan yang akan dibayar, kemudian tekan "YA"</li>
                            <li>Muncul konfirmasi pembayaran. Tekan "YA" untuk melakukan pembayaran</li>
                            <li>Bukti pembayaran dalam bentuk struk agar disimpan sebagai bukti pembayaran yang sah dari Bank Mandiri</li>
                            <li>Transaksi Anda sudah selesai</li>
                            <li>Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Melalui Online</CardTitle>
                        <ol>
                            <li>Kunjungi website Mandiri Internet Banking dengan alamat <a href="https://ib.bankmandiri.co.id/">https://ib.bankmandiri.co.id/</a></li>
                            <li>Login dengan memasukkan USER ID dan PIN</li>
                            <li>Masuk ke halaman Beranda, lalu pilih "Bayar"</li>
                            <li>Pilih "Multi Payment"</li>
                            <li>Pilih "No Rekening Anda"</li>
                            <li>Pilih Penyedia Jasa "PT SINAR DIGITAL TERDEPAN"</li>
                            <li>Pilih "No Virtual Account"</li>
                            <li>Masukkan nomor Virtual Account 88464 xxxx xx</li>
                            <li>Masuk ke halaman konfirmasi 1</li>
                            <li>Apabila benar/sesuai, klik tombol tagihan TOTAL, kemudian klik "Lanjutkan"</li>
                            <li>Masuk ke halaman konfirmasi 2</li>
                            <li>Masukkan Challenge Code yang dikirimkan ke Token Internet Banking Anda, kemudian klik "Kirim"</li>
                            <li>Masuk ke halaman konfirmasi pembayaran telah selesai</li>
                            <li>Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.</li>
                        </ol>                                        
                    </Card>
                </Card>
                <Card>
                    <CardTitle>BNI</CardTitle>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>ATM BNI</CardTitle>
                        <ol>
                            <li>Select "Other Transaction"</li>
                            <li>Select "Transfer"</li>
                            <li>Select the type of account you are using to transfer (i.e. from Savings account)</li>
                            <li>Choose "Virtual Account Billing"</li>
                            <li>Enter virtual account number</li>
                            <li>The amount billed will show on the screen</li>
                            <li>Confirm the transaction, if it's correct then continue</li>
                            <li>Your transaction is completed</li>
                            <li>Once the payment transaction is completed, this invoice will be updated automatically. This may take up to 5 minute</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Internet Banking</CardTitle>
                        <ol>
                            <li>Enter the following address <a href="https://ibank.bni.co.id">https://ibank.bni.co.id</a> and click "Enter"</li>
                            <li>Enter your User ID and Password</li>
                            <li>Select the menu "Transfer"</li>
                            <li>Select the menu "Virtual Account Billing"</li>
                            <li>Enter your Virtual Account number</li>
                            <li>Choose the type of account you are using to transfer and press "Continue"</li>
                            <li>The amount billed will show on the screen</li>
                            <li>Enter the authentication token code</li>
                            <li>Your transaction is completed</li>
                            <li>Once the payment transaction is completed, this invoice will be updated automatically. This may take up to 5 minute</li>
                        </ol>                                        
                    </Card>
                    <Card style={{padding:0}}>
                        <CardTitle style={{fontSize:"1rem"}}>Mobile Banking</CardTitle>
                        <ol>
                            <li>Enter your User ID and Password</li>
                            <li>Select the menu "Transfer"</li>
                            <li>Select the menu "Virtual Account Billing" and then choose debit account</li>
                            <li>Enter your Virtual Account Number on the menu "Input New"</li>
                            <li>The amount billed will show on the screen</li>
                            <li>Confirm the transaction and enter your password</li>
                            <li>Your transaction is completed</li>
                            <li>Once the payment transaction is completed, this invoice will be updated automatically. This may take up to 5 minute</li>
                        </ol>                                        
                    </Card>
                </Card>
            </Card>
        )
    }
}